import React from 'react';
import '../styles/About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-banner">
        <div className="banner-content">
          <h1>About Us</h1>
          <p>Serving Western Washington with Pride Since 2016</p>
        </div>
      </div>

      <section className="about-content" style={{backgroundColor: "white"}}>
        <div className="container">
          <div className="about-intro">
            <h2>Our Story</h2>
            <p>
              Sky Harbor Shuttle is locally owned and operated in Aberdeen, Washington, in the heart of Grays Harbor County. Since 2016, we have been proudly providing quality transportation services to the people of Western and Eastern Washington, prioritizing the comfort and safety of all our clients at all times.
            </p>
            <p>
              What started as a local transportation service has grown into a trusted provider serving all 39 counties across Washington State. Our commitment to excellence and community service has made us a preferred choice for medical transportation, facility transfers, and specialized transport needs throughout the entire state.
            </p>
            <p>
              Sky Harbor Shuttle strives to provide top-tier quality transportation to the residents of Washington State. Our diverse fleet of vehicles can accommodate the needs of those requiring wheelchair transport, ambulatory assistance, stretcher transport, and group shuttle service. Our skilled, professional drivers are trained to get you to and from your destination in a timely, safe, and comfortable fashion.
            </p>
            <p>
              As a locally owned business, we understand the unique needs of our community. We're not just a transportation company—we're your neighbors, committed to ensuring that every journey is handled with care, respect, and professionalism. Whether you're heading to a medical appointment, being discharged from a hospital, or need ongoing transportation for treatments, we're here to serve you.
            </p>
          </div>
        </div>
      </section>

      <section className="values-section" style={{backgroundColor: "#f8f9fa"}}>
        <div className="container">
          <div className="values-grid">
            <div className="value-card">
              <h3>Quality Care</h3>
              <p>Dedicated to providing exceptional transportation services with utmost care and attention.</p>
            </div>
            <div className="value-card">
              <h3>Safety First</h3>
              <p>Maintaining the highest standards of safety and security for all our clients.</p>
            </div>
            <div className="value-card">
              <h3>Reliability</h3>
              <p>Committed to punctual and dependable service for every journey.</p>
            </div>
            <div className="value-card">
              <h3>Compassion</h3>
              <p>Treating each client with dignity, respect, and genuine care.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="mission-section" style={{backgroundColor: "white"}}>
        <div className="container">
          <h2>Our Mission</h2>
          <p>
            To provide top quality care and compassion while transporting clients to and from their destinations, maintaining a safe, secure and comfortable environment. We treat our clients with the dignity and respect that they deserve, all the while providing on-time service.
          </p>
          <p>
            We believe that reliable transportation should never be a barrier to accessing healthcare. Our mission extends beyond simply getting you from point A to point B—we're committed to making every journey as comfortable, safe, and stress-free as possible. Every client matters, every appointment is important, and every ride is an opportunity to serve our community with excellence.
          </p>
        </div>
      </section>

      <section className="commitment-section" style={{backgroundColor: "#f8f9fa"}}>
        <div className="container">
          <h2>Our Commitment to You</h2>
          <div className="commitment-grid">
            <div className="commitment-item">
              <h3>Professional Drivers</h3>
              <p>All our drivers undergo comprehensive training, background checks, and ongoing education to ensure the highest standards of safety and service. They're not just drivers—they're trained professionals dedicated to your well-being.</p>
            </div>
            <div className="commitment-item">
              <h3>Maintained Fleet</h3>
              <p>Our vehicles are regularly inspected and maintained to meet or exceed safety standards. We invest in quality vehicles equipped with the necessary features to accommodate various mobility needs.</p>
            </div>
            <div className="commitment-item">
              <h3>Community Focus</h3>
              <p>As a locally owned business, we're invested in the communities we serve. We understand the unique needs of Washington State residents and are committed to being a reliable transportation partner for years to come.</p>
            </div>
            <div className="commitment-item">
              <h3>Flexible Service</h3>
              <p>We work with Medicaid brokers, insurance providers, and private-pay clients to ensure transportation is accessible. Our flexible scheduling and service options accommodate a wide range of needs.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 